<template>
  <div class="navBar flex">
    <!-- <el-popover
      v-for="(item, index) in listBat"
      :key="index"
      :placement="!item.isPz ? 'top' : 'bottom'"
      title=""
      width="140"
      trigger="hover"
      :content="item.msg"
    >
      <div v-if="item.isPz" slot="content">多行信息<br />第二行信息</div>
      <div class="cube" slot="reference">
        <div class="circle_one">
          <img :src="item.pic" />
        </div>
        <div>
          <span>{{ item.name }}</span>
          <div class="valueNum">
            <span class="num">{{ item.value }}</span>
            <span class="ys">({{ item.unit }})</span>
          </div>
        </div>
      </div>
    </el-popover> -->
    <div v-for="(item, index) in listBat" :key="index">
      <el-popover
        placement="top"
        title=""
        width="140"
        trigger="hover"
        :content="item.msg"
        v-if="!item.isPz"
      >
        <div class="cube" slot="reference">
          <div class="circle_one">
            <img :src="item.pic" />
          </div>
          <div>
            <span>{{ item.name }}</span>
            <div class="valueNum">
              <span class="num">{{ item.value }}</span>
              <span class="ys">({{ item.unit }})</span>
            </div>
          </div>
        </div>
      </el-popover>
      <template v-else>
        <!-- <div slot="content">{{ item.msg }}</div> -->

        <div class="cube tips-hover" slot="reference">
          <div class="tips-box">
            <div v-html="item.msg"></div>
            <div class="tips__arrow"></div>
          </div>
          <div class="circle_one">
            <img :src="item.pic" />
          </div>
          <div>
            <span>{{ item.name }}</span>
            <div class="valueNum">
              <span class="num">{{ item.value }}</span>
              <span class="ys">({{ item.unit }})</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { findIndexByName } from "@/util/index";
import { get } from "@/api/index";
export default {
  data() {
    return {
      isShow: true,
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 产业总览-头部统计数据
      get("/api/dp/visual/queryList?code=zl_headdata").then((res) => {
        if (res.data && res.data.length > 0) {
          const data = res.data[0];
          const item = res.item;
          const itemlen = item.length;
          let pic = "";
          this.listBat = item.map((e, i) => {
            const index = findIndexByName(e.name, item, "name");
            try {
              pic = require("images/index/nav/cyzl/" + e.name + ".png");
            } catch (e) {
              console.log(e);
              pic = require("images/index/nav/cyzl/年产量.png");
            }
            let msg = "统计年份：2024",
              isPz = false;
            if (i === itemlen - 1) {
              msg = "规模种植";
            } else if (e.name.indexOf("荔枝") > -1) {
              msg = `<p>本地原有品种（16个）：三月红、白糖罂，妃子笑，桂味，糯米糍，进奉，鸡嘴荔，黑叶、白蜡、怀枝、晚香玉、马贵荔、水东黑叶、红皮（大灶）、禾虾串、鉴江红糯</p>

<p>近年引种（32个）：仙进奉、井冈红糯、岭丰糯、冰荔、翡脆、观音绿、唐夏红、糯桂，凤山红灯笼、红绣球、御金球；无核荔，荷花大红荔，大丁香、钦州红荔、英山红、玉荷苞、双肩玉荷包、翡脆、新球蜜荔、B13，9918，99112,、凤凰荔，庙种糯，脆绿，北园绿、挂绿、紫娘喜、桂早荔、贵妃红，双白荔</p>

<p>新进品种（24个）：莞植一号，莞植二号，青龙桂味，红美人、巨美人，迟美人，草莓荔，越州红、大唐红、金灵、兰台、D3-49，石坝秀埔荔、宫粉糯、白糯、香种桂味、小荷包、五华晚熟无核、双喜荔、P1-109、W5-32、W5-15、MS137、娇美人</p>

<p>茂名本地新品种（10个）：科技一号、香蜜早，香荔、茂早1号、茂早2号、荷花荔、脆爽，喜荔，茂早3号，茂名早4号</p>`;
              isPz = true;
            }
            if (index > -1) {
              return {
                name: e.name,
                pic,
                msg,
                isPz,
                value: data[item[index]["code"]],
                unit: item[index]["unit"] || "",
              };
            } else {
              return {
                name: e.name,
                pic,
                msg,
                isPz,
                value: "",
                unit: item[index]["unit"] || "",
              };
            }
          });
          console.log("listBat", this.listBat);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
  position relative
  background url('~images/index/nav/navBg.png') center no-repeat
  background-size 100% 100%
  height .35rem
  justify-content center
  width 180px
  opacity .9
  cursor pointer
  display flex
  align-items center

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem

  img
    width .25rem
    height .25rem
    vertical-align middle
.tips-hover:hover
  .tips-box
    display block

.tips-box
  position: absolute;
  background: #fff;
  min-width: 150px;
  border: 1px solid #ebeef5;
  padding: 12px;
  z-index: 2000;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  word-break: break-all;
  border-radius: 4px;
  bottom: -290px;
  width 500px
  left: 50%;
  transform: translateX(-50%);
  animation all 0.5s
  display none

  .tips__arrow
  .tips__arrow:after
    position: absolute;
    top -12px
    left 50%
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 6px;
    border-color transparent transparent #fff transparent
</style>
